
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punestationtomumbaicabs() {



    const cardData =
    {
        keyword: ' Pune Station to Mumbai Cabs Service',
        heading: 'Prince Cabs: Pune Station to Mumbai Cabs Service',
        headingDescription: 'Prince Cabs provides dependable Pune Station to Mumbai Cabs Service, perfect for business trips, airport transfers, family travel, and outstation journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride from Pune Railway Station to any destination in Mumbai. With professional chauffeurs, on-time pickups, and flexible schedules, we guarantee a smooth and hassle-free journey. Experience comfort, reliability, and affordability with Prince Cabs’ trusted cab service from Pune Station to Mumbai.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic monument overlooking the Arabian Sea. Designed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. The site is a favorite gathering point with bustling street vendors and ferry rides to Elephanta Caves. Sunsets here are magical, and the monument glows beautifully when lit at night. It remains the pride of South Mumbai. Gateway of India is the true symbol of Mumbai."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km curved promenade along the Arabian Sea. At night, the streetlights resemble a necklace, creating a stunning visual effect. Locals and tourists enjoy jogging, evening walks, and watching the sunset here. During monsoon, waves crashing onto the promenade create dramatic scenes. It is one of Mumbai’s most romantic and scenic spots. Marine Drive reflects the city’s vibrant spirit."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage Site and Mumbai’s busiest railway hub. Built in 1887, it showcases Gothic Revival architecture with stained glass windows, domes, and carvings. The station is a blend of functionality and heritage beauty. Visitors admire the grandeur of its design, especially when illuminated at night. It is the lifeline of Mumbai’s local train system. CST is a masterpiece of colonial-era architecture."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are ancient rock-cut temples dedicated to Lord Shiva. Dating back to the 5th–6th centuries, the caves feature the iconic Trimurti sculpture. Accessible by ferry from Gateway of India, the site is a UNESCO World Heritage destination. Surrounded by lush greenery, it offers peace away from the city. The caves reflect India’s rich artistic and spiritual legacy. It is a must-visit for history lovers."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, loved for its lively atmosphere and street food. Vendors serve Mumbai’s favorite snacks like pav bhaji, bhel puri, and ice gola. Bollywood celebrities often reside nearby, making it popular for star spotting. Families gather here in the evenings for leisure and sea breezes. Sunsets are breathtakingly beautiful from this spot. Juhu Beach is Mumbai’s coastal heart."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is Mumbai’s most visited shrine dedicated to Lord Ganesha. Built in 1801, the temple attracts thousands of devotees daily, including celebrities and politicians. The temple’s golden dome and intricately carved wooden doors add grandeur. Tuesdays are especially significant for darshan. Devotees believe prayers here are always fulfilled. It is the spiritual soul of Mumbai."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an eight-lane cable-stayed bridge connecting South Mumbai to the suburbs. It is a modern engineering marvel offering panoramic views of the Arabian Sea. Driving across it, especially at night when it’s lit, is an unforgettable experience. It has reduced travel time and transformed city connectivity. The bridge is both practical and scenic. It stands as a modern symbol of Mumbai’s progress."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a revered mosque and tomb situated on an islet in the Arabian Sea. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it attracts devotees of all faiths. The causeway leading to the dargah is accessible only during low tide. Its Indo-Islamic architecture is striking against the sea backdrop. The site combines spirituality with beauty. Haji Ali is Mumbai’s sacred landmark of unity."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s famous shopping street buzzing with vendors and boutiques. Visitors shop for handicrafts, jewelry, clothes, and antiques at budget-friendly rates. Iconic cafés like Leopold Café and Café Mondegar add to its charm. Bargaining with street vendors is part of the fun. It is always lively with locals and tourists. Colaba Causeway is the ultimate shopping and cultural hotspot of Mumbai."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a lively beach in South Mumbai, best known for Ganesh Visarjan festivities. Families and couples enjoy spending evenings here with snacks like pav bhaji and kulfi. The beach is vibrant during festivals and cultural events. It offers stunning views of Marine Drive and the Arabian Sea. Children enjoy playing in the sand and waves. Chowpatty is a place of leisure, tradition, and celebration."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City in Goregaon is the hub of Bollywood filmmaking, spread across 500 acres. It has studios, artificial sets, and shooting locations for movies and TV shows. Visitors can take guided tours to see behind-the-scenes action. It is one of the largest film production centers in India. Film City defines Mumbai’s identity as the entertainment capital. It is a dream destination for cinema lovers."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a vast green sanctuary within Mumbai, spread over 87 sq. km. It is home to leopards, deer, and hundreds of bird species. The park also houses the ancient Kanheri Caves with Buddhist monasteries and stupas. Visitors enjoy safaris, treks, and toy train rides. It is rare to find such biodiversity within a metropolis. The park is a unique mix of history and nature."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is an artificial lake located in the city’s suburban area. Surrounded by greenery and skyscrapers, it is a favorite spot for walkers and birdwatchers. Birds like kingfishers, herons, and migratory species are often spotted here. The lake looks stunning during monsoon with misty views. Photographers capture striking reflections of the skyline. Powai Lake is Mumbai’s natural escape."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda, located near Gorai, is one of the world’s largest meditation domes. Built in Burmese architectural style, it houses relics of Buddha. The golden structure accommodates thousands of meditators. Visitors attend sessions and admire its grandeur. Its seaside setting makes it even more peaceful. The pagoda is a spiritual and architectural wonder."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Nehru Planetarium, located in Worli, is an educational and entertaining hub for astronomy lovers. It offers sky shows about stars, planets, and galaxies in its dome-shaped auditorium. The adjoining Science Centre has interactive exhibits on technology and innovation. Families and students enjoy its informative environment. Special events during eclipses and space phenomena attract large crowds. It inspires curiosity and learning in young minds."
  }
],

"services": [
  {
    "name": "Pune Railway Station to Mumbai Taxi",
    "description": "Book a comfortable taxi from Pune Railway Station to Mumbai for a hassle-free intercity journey. Ideal for travelers arriving by train, our taxi service ensures timely pickups, air-conditioned vehicles, and courteous drivers. Choose from multiple vehicle options including sedans, SUVs, and MPVs to match your comfort and budget."
  },
  {
    "name": "Pune Station to Mumbai Cab Booking",
    "description": "Easily book cabs from Pune Station to Mumbai with instant confirmation and reliable service. Whether you're heading to a business meeting, a family visit, or a flight connection, our cab booking system offers flexible options and smooth travel experiences with professional drivers."
  },
  {
    "name": "Pune Station to Mumbai Innova",
    "description": "Travel from Pune Station to Mumbai in a spacious Innova, perfect for families or groups with luggage. Enjoy ample space, superior comfort, and a smooth ride with our premium Innova cab service—ideal for long-distance intercity travel."
  },
  {
    "name": "Pune Station to Mumbai One Way Cab",
    "description": "Book a one way cab from Pune Station to Mumbai at affordable rates. Our service includes door-to-door pickup, clean vehicles, and punctual drivers—making it a convenient choice for those not planning a return trip."
  },
  {
    "name": "Pune Station to Mumbai Airport Cab",
    "description": "Get reliable cab services from Pune Railway Station to Mumbai Airport for timely flight connections. Choose from sedans, SUVs, or luxury cars depending on your travel needs and enjoy a stress-free airport transfer."
  },
  {
    "name": "Pune Station to Mumbai Dzire Taxi",
    "description": "Opt for a budget-friendly yet comfortable ride from Pune Station to Mumbai with Swift Dzire taxis. Best suited for solo travelers and small families, the Dzire offers a smooth ride with AC and enough space for luggage."
  },
  {
    "name": "Pune Station to Mumbai Crysta Cab",
    "description": "Book a Toyota Innova Crysta cab from Pune Station to Mumbai for premium travel comfort. With plush interiors, excellent legroom, and ample luggage space, it’s the perfect choice for those looking to travel in style and convenience."
  },
  {
    "name": "Pune Station to Mumbai Ertiga Cab",
    "description": "Hire an Ertiga cab from Pune Station to Mumbai for a spacious and economical journey. The 6–7 seater Ertiga is ideal for families or small groups looking for a smooth intercity ride without breaking the bank."
  },
  {
    "name": "Pune Station to Mumbai Cab Fare",
    "description": "Check transparent cab fare details for trips from Pune Railway Station to Mumbai. No hidden charges—just fair, competitive rates based on your vehicle choice and travel distance."
  },
  {
    "name": "Affordable Pune Station to Mumbai Cabs",
    "description": "Looking for affordable cabs from Pune Station to Mumbai? Our budget-friendly services offer safe, clean, and timely rides with professional drivers—making it the smart choice for economical travel."
  },
  {
    "name": "Sedan Cab from Pune Station to Mumbai",
    "description": "Hire a sedan cab from Pune Station to Mumbai for a cost-effective and comfortable ride. Vehicles like Dzire and Etios are perfect for 2–4 passengers with light luggage, ensuring a smooth and quiet journey."
  },
  {
    "name": "Pune Station to Mumbai Drop Taxi",
    "description": "Use our drop taxi service from Pune Station to Mumbai for one-way travel at great prices. Quick pickups, fixed fares, and experienced drivers make this the ideal choice for single-side intercity transfers."
  },
  {
    "name": "AC Cabs Pune Station to Mumbai",
    "description": "Travel in comfort with fully air-conditioned cabs from Pune Railway Station to Mumbai. Our fleet includes sedans, SUVs, and MPVs—ensuring a pleasant ride regardless of the weather or distance."
  },
  {
    "name": "Pune Station to Mumbai Family Cab",
    "description": "Book a family cab from Pune Station to Mumbai with spacious vehicles like Ertiga or Innova, designed to accommodate luggage and passengers comfortably for a stress-free family trip."
  },
  {
    "name": "Fast Cab from Pune Station to Mumbai",
    "description": "Get fast cab services from Pune Station to Mumbai with minimal wait times, experienced drivers, and well-maintained vehicles. Ideal for last-minute travelers or urgent appointments in Mumbai."
  }
],
"tableData": [
  ["Pune Railway Station to Mumbai Taxi", "Pune Station to Mumbai Cab Booking"],
  ["Pune Station to Mumbai Innova", "Pune Station to Mumbai One Way Cab"],
  ["Pune Station to Mumbai Airport Cab", "Pune Station to Mumbai Dzire Taxi"],
  ["Pune Station to Mumbai Crysta Cab", "Pune Station to Mumbai Ertiga Cab"],
  ["Pune Station to Mumbai Cab Fare", "Affordable Pune Station to Mumbai Cabs"],
  ["Sedan Cab from Pune Station to Mumbai", "Pune Station to Mumbai Drop Taxi"],
  ["AC Cabs Pune Station to Mumbai", "Pune Station to Mumbai Family Cab"],
  ["Fast Cab from Pune Station to Mumbai"]
],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Pune Station to Mumbai Cab Service",
    "WhyChoosedescription": "Prince Cabs offers reliable cab service from Pune Railway Station to Mumbai, catering to travelers looking for a smooth, on-time, and comfortable transfer. Whether you're heading to South Mumbai, Mumbai suburbs, or the airport, we ensure a stress-free journey starting right from your train’s arrival. With timely pickups and trained drivers waiting at the station, you can avoid long waits and crowded local options."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Every Travel Need",
    "WhyChoosedescription": "Choose from our fleet of well-maintained vehicles including sedans (like Swift Dzire, Honda Amaze), SUVs (like Innova Crysta), and premium cars for your Pune Station to Mumbai trip. Whether you're traveling solo, as a couple, or in a group, we have options that suit your comfort and luggage needs. Each car is equipped with AC, clean interiors, and safety features to enhance your travel experience."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Fixed Pricing",
    "WhyChoosedescription": "We provide fixed and all-inclusive cab fares for transfers from Pune Station to Mumbai, so you don’t have to worry about surge pricing or hidden costs. The fare includes fuel, tolls, driver allowance, and taxes. No surprises at the end of your journey—just transparent, budget-friendly pricing tailored to your route and vehicle type."
  },
  {
    "WhyChooseheading": "Seamless Station Pickup with Real-Time Coordination",
    "WhyChoosedescription": "Our drivers coordinate with you in real-time upon train arrival, ensuring a quick and hassle-free pickup from Pune Railway Station. We track train delays and adjust driver timings accordingly. This ensures you’re not left waiting and your journey to Mumbai starts without unnecessary stress. Look for your driver at the station exit holding a name board, or connect directly via call or WhatsApp."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "Our cab drivers are well-trained, background-verified, and have extensive experience with the Pune to Mumbai route. They prioritize safe driving, punctuality, and customer service—offering help with luggage, maintaining polite communication, and ensuring you reach your destination comfortably and efficiently."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Safe Vehicles",
    "WhyChoosedescription": "Your safety is our top priority. Every cab is cleaned and sanitized before every trip, with a focus on hygiene, especially for pickups from public places like Pune Station. Our vehicles are regularly maintained, and equipped with seat belts, airbags, and GPS tracking for added security throughout your journey to Mumbai."
  },
  {
    "WhyChooseheading": "24/7 Customer Support and Easy Booking",
    "WhyChoosedescription": "Prince Cabs offers 24/7 support for bookings and real-time travel assistance. You can book your cab in advance or on short notice via call, WhatsApp, or our website. Our support team is always available to help with schedule adjustments, payment queries, or emergency support, ensuring peace of mind throughout your Pune to Mumbai journey."
  }
]
























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide cab service from Pune Railway Station to Mumbai?',
        answer: 'Yes, Prince Cabs offers reliable cab services from Pune Station to Mumbai for both one-way and round trips.',
    },
    {
        question: 'What types of cabs are available from Pune Station to Mumbai?',
        answer: 'We offer a variety of cabs including Swift Dzire, Innova, Ertiga, and Tempo Traveller to suit your travel needs and group size.',
    },
    {
        question: 'How long does it take to travel from Pune Station to Mumbai by cab?',
        answer: 'The travel time is approximately 3 to 4 hours depending on traffic and road conditions.',
    },
    {
        question: 'Can I pre-book a cab from Pune Railway Station to Mumbai?',
        answer: 'Yes, you can pre-book your cab through our website or by calling our customer support team for hassle-free travel.',
    },
    {
        question: 'Are your cabs clean and well-maintained for intercity travel?',
        answer: 'Absolutely! All cabs are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What is the fare for a cab from Pune Station to Mumbai?',
        answer: 'Cab fares vary based on the type of vehicle and travel time. Please contact Prince Cabs for an accurate and competitive quote.',
    },
    {
        question: 'Is there cab availability at odd hours from Pune Station to Mumbai?',
        answer: 'Yes, Prince Cabs offers 24/7 service from Pune Station to Mumbai, including early morning and late-night pickups.',
    },
];

const testimonials = [
    {
        name: "Mr. Nilesh Pawar",
        position: "Frequent Rail Traveler",
        text: "Prince Cabs provided excellent service from Pune Station to Mumbai. The driver was punctual, and the ride was smooth.",
        image: "/img/testimonial/testimonial-thumb-pune-station-mumbai-1.png",
    },
    {
        name: "Mrs. Radhika Mehta",
        position: "Family Traveler",
        text: "Our cab from Pune Railway Station to Mumbai was clean and comfortable. Prince Cabs made our journey stress-free.",
        image: "/img/testimonial/testimonial-thumb-pune-station-mumbai-2.png",
    },
];






































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune Station to Mumbai Cabs Service",
  "description": "Book reliable cab services from Pune Railway Station to Mumbai, including options like Innova Crysta, Dzire, Ertiga, and Sedans. One-way, drop, and family cab options available at affordable fares.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune Railway Station to Mumbai Taxi",
    "Pune Station to Mumbai Cab Booking",
    "Pune Station to Mumbai Innova",
    "Pune Station to Mumbai One Way Cab",
    "Pune Station to Mumbai Airport Cab",
    "Pune Station to Mumbai Dzire Taxi",
    "Pune Station to Mumbai Crysta Cab",
    "Pune Station to Mumbai Ertiga Cab",
    "Pune Station to Mumbai Cab Fare",
    "Affordable Pune Station to Mumbai Cabs",
    "Sedan Cab from Pune Station to Mumbai",
    "Pune Station to Mumbai Drop Taxi",
    "AC Cabs Pune Station to Mumbai",
    "Pune Station to Mumbai Family Cab",
    "Fast Cab from Pune Station to Mumbai"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune Station to Mumbai Cab | Book Innova, Dzire, Ertiga & More</title>
  <meta
    name="description"
    content="Book fast and affordable cabs from Pune Railway Station to Mumbai. Choose from Innova Crysta, Dzire, Sedan, or Ertiga for one-way drops, family travel, or airport transfers."
  />
  <meta
    name="keywords"
    content="Pune Railway Station to Mumbai Taxi, Pune Station to Mumbai Cab Booking, Pune Station to Mumbai Innova, Pune Station to Mumbai One Way Cab, Pune Station to Mumbai Airport Cab, Pune Station to Mumbai Dzire Taxi, Pune Station to Mumbai Crysta Cab, Pune Station to Mumbai Ertiga Cab, Pune Station to Mumbai Cab Fare, Affordable Pune Station to Mumbai Cabs, Sedan Cab from Pune Station to Mumbai, Pune Station to Mumbai Drop Taxi, AC Cabs Pune Station to Mumbai, Pune Station to Mumbai Family Cab, Fast Cab from Pune Station to Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/61.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punestationtomumbaicabs ;